import { render, staticRenderFns } from "./insertCharacter.vue?vue&type=template&id=95e537de&"
import script from "./insertCharacter.vue?vue&type=script&lang=js&"
export * from "./insertCharacter.vue?vue&type=script&lang=js&"
import style0 from "./insertCharacter.vue?vue&type=style&index=0&id=95e537de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports